import { constants as basicConfirmModalConstants } from './components/confirm_modal/basic_confirm_modal';

export const NAME = 'common';
export const API_URL = process.env.API_BASE_URL;

export const AUTH_TOKEN_NAME = 'breezeway_token';
export const ADMIN_TOKEN_NAME = 'admin_token';
export const TASK_TOKEN_NAME = 'task_token';
export const LAST_TASK_TOKEN_NAME = 'last_task_token';

export { basicConfirmModalConstants };
